import type { NormalizedAttachment } from './parseEml';

async function blobToDataUrl(blob: Blob): Promise<string> {
  return new Promise((resolve, reject) => {
    const fr = new FileReader();
    fr.onload = () => resolve(fr.result as string);
    fr.onerror = () => reject(fr.error ?? new Error('read failed'));
    fr.readAsDataURL(blob);
  });
}

/**
 * Replace cid:... image references with data URLs for local preview/conversion.
 */
export async function resolveCidInHtml(
  html: string,
  attachments: NormalizedAttachment[],
): Promise<string> {
  let out = html;
  const withCid = attachments.filter((a) => a.contentId && a.mimeType.startsWith('image/'));
  for (const a of withCid) {
    const cid = a.contentId as string;
    const blob = new Blob([new Uint8Array(a.content)], { type: a.mimeType });
    const dataUrl = await blobToDataUrl(blob);
    const safeCid = cid.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
    out = out.replace(new RegExp(`cid:${safeCid}`, 'gi'), dataUrl);
  }
  return out;
}
